<div *ngIf="hasImage && imageUrl && loaded" [style.backgroundImage]="'url('+ imageUrl +')' | safe:'style'"
	class="avatarImageUnverified">
</div>

<div *ngIf="imageUrl && !hasImage && kioskCheck && loaded"
	[style.backgroundImage]="'url('+ imageUrl +')' | safe:'style'" class="avatarImageUnverified logoImageCenter">
</div>

<app-text-avatar *ngIf="!hasImage && !kioskCheck && loaded && profile" exportparts="avatar" [avatarName]="profile?.avatarName"
	[avatarColor]="profile?.color" class="avatarPlain">
</app-text-avatar>

<div *ngIf="!loaded" class="avatarImageUnverified">
	<ion-skeleton-text style="width: 100%; height: 100%;" *ngIf="!loaded" rounded animated></ion-skeleton-text>
</div>